import React from 'react'
import styled from '@emotion/styled'

const StaticVideoWrapper = ({ ratio, color, className, ...props }) => (
  <div className={className}>
    <video autoPlay loop playsInline muted {...props} />
  </div>
)

const StaticVideo = styled(StaticVideoWrapper)(
  {
    position: 'relative',
    overflow: 'hidden',
    '::after': {
      content: '""',
      display: 'block',
    },
    video: {
      display: 'block',
      width: '100%',
      height: '100%',
      position: 'absolute',
      left: 0,
      top: 0,
      objectFit: 'cover',
    },
  },
  ({ ratio = 2 / 3, color = '#000' }) => ({
    backgroundColor: color,
    '::after': { paddingTop: `${ratio * 100}%` },
  })
)

export default StaticVideo
